export enum InForceProductGroup {
  LIFE = "Life",
  ANNUITY = "Annuity",
}
